/* Ability Warehouse — product page hooks for the fit check and the sticky add-to-cart bar (v33).
   Adds, without touching sections/main-product.liquid:
     1. the "Is this right for me?" entry card under the price block (opens the fit-check drawer),
     2. a "Check fit" text link in the sticky bar's top strip, next to the member line,
     3. a 44×44 thumbnail (first image, or the selected variant's image) at the far left of the bar's bottom row.
        Tapping it scrolls smoothly to the gallery and opens the viewer on that image (window.AWGallery, assets/gallery.js). */
(function () {
  'use strict';
  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fs = null;
  try { fs = JSON.parse(document.getElementById('aw-fs-data').textContent); } catch (e) {}
  function sized(src, w) { return src ? src.replace(/([?&])width=\d+/, '$1width=' + w) : ''; }

  /* 1. entry card under the buy unit ("Members save" + Add to cart) */
  var buy = pdp.querySelector('.pdp-buyunit');
  if (buy && !pdp.querySelector('[data-fit-entry]')) {
    var after = buy.nextElementSibling && buy.nextElementSibling.matches('.pdp-under') ? buy.nextElementSibling : buy;
    after.insertAdjacentHTML('afterend',
      '<div class="hmc-entry" data-fit-entry>' +
      '<span class="hmc-entry__ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3 8-8"/><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9"/></svg></span>' +
      '<span class="hmc-entry__t"><b>Does it fit?</b><small>Check in 60 seconds against the published sizes</small><span class="hmc-entry__state" data-fit-entry-state hidden></span></span>' +
      '<button type="button" class="hmc-entry__btn" data-fit-open aria-haspopup="dialog">Check fit</button></div>');
  }
  /* 1b. buying-guide card (snippets/aw-fit-guides.liquid, rendered hidden at the end of the page): moved under the
     entry card in the same frame, so the buy card only reflows once */
  var guides = document.querySelector('[data-fit-guides]'), entry = pdp.querySelector('[data-fit-entry]');
  if (guides && (entry || buy)) { (entry || buy).insertAdjacentElement('afterend', guides); guides.hidden = false; }

  /* 1c. unify the fit tool: the old "Is it right for you?" height/weight slider in the Specifications tab becomes
     the one "Does it fit?" launcher that opens the same drawer (data-fit-open). Only where the old panel was shown. */
  var fp = document.querySelector('.pdp-fitpanel[data-fitpanel]');
  if (fp && !fp.hasAttribute('hidden')) {
    fp.removeAttribute('data-fitpanel');
    fp.classList.add('pdp-fitcta');
    fp.innerHTML =
      '<span class="pdp-fitcta__ic" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3 8-8"/><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9"/></svg></span>' +
      '<h3 class="pdp-h3">Does it fit?</h3>' +
      '<p class="pdp-fitcta__s">Answer a few quick questions and we’ll check this model against its published sizes — weight rating, overall width, seat and handle height — and tell you which size suits.</p>' +
      '<button type="button" class="pdp-fitcta__btn" data-fit-open aria-haspopup="dialog">Check fit</button>' +
      '<p class="pdp-fine">Guidance only. We’ll say if something else suits better.</p>';
  }

  /* 2 + 3. sticky bar: "Check fit" in the top strip, thumbnail at the far left of the bottom row */
  var bar = pdp.querySelector('[data-bar]');
  if (bar) {
    var inner = bar.querySelector('.pdp-bar__in'), top = bar.querySelector('.pdp-bar__top'), addq = bar.querySelector('.pdp-bar__addq');
    if (inner && !top) { top = document.createElement('div'); top.className = 'pdp-bar__top'; inner.insertBefore(top, inner.firstChild); }
    if (top && !top.querySelector('[data-fit-open]')) {
      var link = document.createElement('button');
      link.type = 'button'; link.className = 'pdp-bar__fit'; link.setAttribute('data-fit-open', ''); link.setAttribute('aria-haspopup', 'dialog'); link.textContent = 'Does it fit?';
      var chip = top.querySelector('[data-bar-var]');
      if (chip) top.insertBefore(link, chip); else top.appendChild(link);
    }
    var first = fs && fs.images && fs.images[0];
    if (addq && first && !bar.querySelector('[data-bar-thumb]')) {
      var row = document.createElement('div'); row.className = 'pdp-bar__row';
      addq.parentNode.insertBefore(row, addq);
      row.innerHTML = '<button type="button" class="pdp-bar__thumb" data-bar-thumb aria-label="Show product photos"><img src="' + sized(first, 88) + '" alt="" width="44" height="44" loading="lazy" data-bar-thumb-img></button>';
      row.appendChild(addq);
      var btn = row.querySelector('[data-bar-thumb]'), img = btn.querySelector('img'), current = 0;
      document.addEventListener('aw:variant', function (e) {
        // variant-picker.js sends Shopify's product-JSON variant: featured_image {src} or null; #aw-fs-data has the same per variant id
        var v = e.detail || {}, src = '';
        var fi = v.featured_image; if (fi) src = typeof fi === 'string' ? fi : fi.src;
        if (!src && fs && fs.variants) { var vv = fs.variants.filter(function (x) { return String(x.id) === String(v.id); })[0]; if (vv && vv.image) src = vv.image; }
        img.src = src ? (/width=/.test(src) ? sized(src, 88) : src.replace(/(\.[a-z]+)(\?|$)/i, '_88x88$1$2')) : sized(first, 88);
        current = 0;
        if (src) {
          var key = src.split('?')[0].replace(/_\d+x\d+/, '').split('/').pop();
          var slides = document.querySelectorAll('[data-g-open]');
          for (var i = 0; i < slides.length; i++) if ((slides[i].dataset.full || '').indexOf(key) > -1) { current = i; break; }
        }
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // pdp.js scrolls the bar to the buy card on desktop; the thumb has its own job
        var g = document.querySelector('[data-gallery]');
        var y = g ? g.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0) - 12 : 0;
        window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
        if (window.AWGallery && window.AWGallery.open) setTimeout(function () { window.AWGallery.open(current); }, reduce ? 0 : 350);
      });
    }
  }
})();
